import { render } from "./QualityControlBoard.vue?vue&type=template&id=78c05f1e"
import script from "./QualityControlBoard.vue?vue&type=script&lang=js"
export * from "./QualityControlBoard.vue?vue&type=script&lang=js"

import "./QualityControlBoard.vue?vue&type=style&index=0&id=78c05f1e&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__